let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8uZOV")).then(() => parcelRequire('hIy02'));